import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";

type State = {
  IdSaidaProduto: number;
  FuncionarioPesquisa: number;
  ProdutoPesquisa: number;
  pesquisa: string | null;
  centroDeCustoSaida: number[];
  centroDeCustoDestino: number[];
  centroDeCustoLista: CentroCustoDropDown[] | undefined;
  dataSaidaDe: Date | null,
  dataSaidaAte: Date | null,
};

type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setFuncionarioPesquisa: SetFunction<number>;
  setProdutoPesquisa: SetFunction<number>;
  setPesquisa: SetFunction<string | null>;
  setCentroDeCustoSaida: SetFunction<number[]>;
  setCentroDeCustoDestino: SetFunction<number[]>;
  setCentroDeCustoLista: SetFunction<CentroCustoDropDown[]>;
};

export const initialFiltersValues: State = {
  IdSaidaProduto: 0,
  FuncionarioPesquisa: 0,
  ProdutoPesquisa: 0,
  pesquisa: "",
  centroDeCustoSaida: [],
  centroDeCustoDestino: [],
  centroDeCustoLista: undefined,
  dataSaidaDe: null,
  dataSaidaAte: null,

};

export const useSaidaProdutoFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setPesquisa: (vfn) => SetFunctionImpl(set, 'pesquisa', vfn),
  setProdutoPesquisa: (vfn) => SetFunctionImpl(set, 'ProdutoPesquisa', vfn),
  setCentroDeCustoSaida: (vfn) => SetFunctionImpl(set, 'centroDeCustoSaida', vfn),
  setCentroDeCustoDestino: (vfn) => SetFunctionImpl(set, 'centroDeCustoDestino', vfn),
  setCentroDeCustoLista: (vfn) => SetFunctionImpl(set, 'centroDeCustoLista', vfn),
  setFuncionarioPesquisa: (vfn) => SetFunctionImpl(set, 'FuncionarioPesquisa', vfn),
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
    centroDeCustoLista: state.centroDeCustoLista
  })),
}));